import type { ConfigurationPeriodDataApiType } from '@naturehouse/design-system/components/atoms/period/models/ConfigurationPeriodModel';
import type HttpError from '@naturehouse/nh-essentials/lib/requests/HttpError';
import CollectionBase from '../../common/CollectionBase';
import { PeriodStorageCollectionType } from '../app/PeriodStorageManager';
import type { BasePeriodCollectionParamsType } from './BasePeriodCollectionParams.type';

export type PeriodConfigurationCollectionParamsType = BasePeriodCollectionParamsType & {
    blockId?: string;
};

export type PeriodConfigurationCollectionDataType = Omit<
    ConfigurationPeriodDataApiType,
    'id' | 'type'
>;
export default class PeriodConfigurationCollection extends CollectionBase<
    PeriodConfigurationCollectionDataType,
    PeriodConfigurationCollectionParamsType
> {
    protected name = PeriodStorageCollectionType.CONFIGURATION;

    static #instance: PeriodConfigurationCollection | null = null;

    public static getInstance(): PeriodConfigurationCollection {
        if (this.#instance === null) {
            this.#instance = new PeriodConfigurationCollection();
        }

        return this.#instance;
    }

    public async retrieve<RT = ConfigurationPeriodDataApiType[]>(
        params?: PeriodConfigurationCollectionParamsType
    ): Promise<RT | void> {
        return super.retrieve<RT>(params);
    }

    public add<RT = AjaxResponse>(
        data: PeriodConfigurationCollectionDataType,
        params: PeriodConfigurationCollectionParamsType
    ): Promise<RT | void> {
        return super.add<AjaxResponse>(data, params) as Promise<RT | void>;
    }

    public async delete(params?: PeriodConfigurationCollectionParamsType): Promise<void> {
        return super.delete(params) as Promise<void>;
    }

    public async update<RT = AjaxResponse>(
        data: PeriodConfigurationCollectionDataType,
        params: PeriodConfigurationCollectionParamsType
    ): Promise<RT | void> {
        return super.update<AjaxResponse>(data, params) as Promise<RT | void>;
    }

    protected endpoint(params: PeriodConfigurationCollectionParamsType): string {
        if (!params || !params.houseId) {
            throw new Error('houseId is required');
        }

        return `/api/houses/${params.houseId}/periods/configurations`;
    }

    protected updateEndpoint(params?: PeriodConfigurationCollectionParamsType | undefined): string {
        if (!params || !params.houseId || !params.blockId) {
            throw new Error('houseId & blockID are required');
        }

        return `/api/houses/${params.houseId}/periods/configurations/${params.blockId}`;
    }

    protected onError(error: HttpError<AjaxResponseError>): void {
        throw new Error(error.body?.message);
    }
}
